import React from 'react';
import { Navigate } from 'react-router-dom';

import { STORAGE_KEYS } from '../../constants/storage';

/**
 * ProtectedRoute Component
 * 
 * Protects routes that require user registration/authentication.
 * Redirects to /register if user is not registered.
 */
const ProtectedRoute = ({ children }) => {
  // Check if user is registered (stored in localStorage)
  const isRegistered = localStorage.getItem(STORAGE_KEYS.USER_REGISTERED) === 'true';

  if (!isRegistered) {
    // Redirect to register page if not registered
    return <Navigate to="/register" replace />;
  }

  // Render protected content if registered
  return children;
};

export default ProtectedRoute;

